import React from "react";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import { privacyPolicyData } from "./data.js";

// Styled Components
const PrivacyWrapper = styled.div`
  margin-top: 90px;
  background-color: #fff;
  padding: 60px 20px;
`;

const PrivacyContainer = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const Section = styled.section`
  margin-bottom: 50px;
`;

const SectionTitle = styled.h1`
  font-size: 28px;
  font-weight: 900;
  color: #9d2222;
  margin-bottom: 20px;
  line-height: 1.4;
  text-align: left;
`;

// Markdown text styling
const MarkdownStyled = styled(ReactMarkdown)`
  font-size: 17px;
  font-family: 'Roboto', sans-serif;
  line-height: 1;
  color: #000;
  text-align: left;
  font-weight: 200;

  p {
    all: unset;
    font-weight: 300;
    margin: 0;
  }

  ul {
    padding-left: 25px;
    /* margin-bottom: 20px; */
  }

  li {
  list-style-type: disc;
  color: #1a1a1a;
  font-weight: 200;
  padding: 0;
  /* margin-bottom: 6px; */
  margin: 0;
}

  strong, b {
    font-weight: 700;
  }

  em, i {
    font-style: italic;
  }
`;

export function PrivacyPolicy() {
  return (
    <PrivacyWrapper>
      <PrivacyContainer>
        {privacyPolicyData.map((section) => (
          <Section key={section.id}>
            <SectionTitle>{section.title}</SectionTitle>
            <MarkdownStyled>{section.text}</MarkdownStyled>
          </Section>
        ))}
      </PrivacyContainer>
    </PrivacyWrapper>
  );
}
